<script>
import AdminOverviewReports from '@/layerAdmin/components/AdminOverviewReports.vue';

export default {
  components: {
    AdminOverviewReports,
  },

  data: () => ({
    batches: [],
  }),
}
</script>

<template>
  <div>

    <api-loader
      method="get"
      url="v1/layeradmin/batches/expanded"
      @loaded="batches=$event" />

    <admin-overview-reports v-if="batches && batches.length > 0" :batches="batches" />
  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AdminOverviewReportsContainer.vue